module.exports = __webpack_public_path__ + "fonts/KaTeX_Math-BoldItalic.48155e43.woff";